module.exports = __webpack_public_path__ + "img/arrow-left.6aab2b38.svg";